import { compact } from 'lodash';

type BorrowerName = {
  firstName: string;
  middleName?: string | null;
  lastName?: string | null; // this should not happen in reality, but some definitions of lastName still have an optional type
  suffix?: string | null;
};

export const getBorrowerLastNameWithSuffix = (borrowerName: BorrowerName | undefined): string => {
  if (!borrowerName) {
    return '';
  }
  const { lastName, suffix } = borrowerName;
  return compact([lastName, suffix]).join(' ');
};

export const getBorrowerNameWithoutMiddleName = (borrowerName: BorrowerName | undefined): string => {
  if (!borrowerName) {
    return '';
  }
  const { firstName, lastName, suffix } = borrowerName;
  return compact([firstName, lastName, suffix]).join(' ');
};

/** Full name (first, middle, last, suffix) */
export const getBorrowerFullName = (borrowerName: BorrowerName | undefined): string => {
  if (!borrowerName) {
    return '';
  }
  const { firstName, middleName, lastName, suffix } = borrowerName;
  return compact([firstName, middleName, lastName, suffix]).join(' ');
};
